import { EntityEnums } from "../enums";

export const virtualityDict = [
  {
    value: EntityEnums.Virtuality.Reality,
    label: "reality",
    info: "",
  },
  {
    value: EntityEnums.Virtuality.Possibility,
    label: "possibility",
    info: "",
  },
  {
    value: EntityEnums.Virtuality.Probability,
    label: "probability",
    info: "",
  },
  {
    value: EntityEnums.Virtuality.Certitude,
    label: "certitude",
    info: "",
  },
  {
    value: EntityEnums.Virtuality.Allegation,
    label: "allegation",
    info: "",
  },
  {
    value: EntityEnums.Virtuality.Semblance,
    label: "semblance",
    info: "",
  },
];
